import React, { useEffect, useMemo, useState } from 'react';
import { Callout, H5, Intent } from '@blueprintjs/core';
import uuid from 'utils/uuid';

import useEditorContext from '../../../context/editorContext';
import useEditorItemContext from '../../../context/editorItemContext';
import NumberOfGenerationsSelect from '../../../components/ancestry/numberOfGenerationsSelect';
import EventListCard from '../../components/eventListCard';
import EventFormControl from '../../components/eventFormControl';
import eventsApi from '../../../api/events';

const ClassicPanel = () => {
  const { item } = useEditorItemContext();
  const editorContext = useEditorContext();

  const [error, setError] = useState();

  const [years, setYears] = useState();
  const [classicEvents, setClassicEvents] = useState();

  const [selectedYear, setSelectedYear] = useState();

  useEffect(() => {
    (async () => {
      const { data, error: eventsError } = await eventsApi(
        editorContext.accessToken,
      ).getClassicEvents();

      if (eventsError) {
        setYears([]);
        return;
      }

      setClassicEvents(data.events);
      setYears(data.years);
      setSelectedYear(data.years[0]);
    })();
  }, []);

  const events = useMemo(() => {
    if (classicEvents && selectedYear) {
      if (classicEvents[selectedYear]) {
        return classicEvents[selectedYear].map(event => ({
          key: uuid(),
          date: event.date,
          description: event.caption,
        }));
      }
    }

    return [];
  }, [classicEvents, selectedYear]);

  const handleOnAddEvents = selectedEvents => {
    editorContext.addEvents(
      item.id,
      selectedEvents.map(event => ({
        key: uuid(),
        date: event.date,
        description: event.description,
        type: 'classic',
      })),
    );
  };

  if (!years) {
    return null;
  }

  if (error) {
    return (
      <>
        <Callout intent={Intent.DANGER}>
          Oh no! We’re sorry, something has gone wrong. We’re working to fix the issue. In the
          meantime, you could try refreshing your page.
        </Callout>
      </>
    );
  }

  if (years.length === 0) {
    return <H5>Sorry, we didn&apos;t find any MyCanvas Classic events.</H5>;
  }

  return (
    <>
      <H5 className="mb-3">Select events from your MyCanvas Classic creations</H5>

      <EventFormControl label="Select year">
        <NumberOfGenerationsSelect
          fill
          values={years}
          selectedValue={selectedYear}
          onChange={setSelectedYear}
        />
      </EventFormControl>

      <EventListCard events={events} onAddEvents={handleOnAddEvents} />
    </>
  );
};

export default ClassicPanel;
